import src from "IMAGE";
export default { src, width: 651, height: 434, blurWidth: 0, blurHeight: 0};
